import { FC } from "react";
import SoftBadge from "./SoftBadge";

const UnknownBadge: FC = () => {
  return (
    <h6 className="mb-0 text-700 fs--1">
      <SoftBadge bg="warning">Inconnu</SoftBadge>
    </h6>
  );
};

export default UnknownBadge;
